import script from "./GeoItemSearchComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoItemSearchComment.vue?vue&type=script&setup=true&lang=ts"

import "./GeoItemSearchComment.vue?vue&type=style&index=0&id=4e42c5c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e42c5c3"]])

export default __exports__